import { useEffect, useState } from 'react';
import { geojsonToMapGeojson } from 'utils/Helper';

export const useMapGeojson = (geojson, zone) => {
  const [mapGeojson, setMapGeojson] = useState(null);

  useEffect(() => {
    if (geojson?.features?.length) {
      setMapGeojson(geojsonToMapGeojson(geojson, zone));
    } else {
      setMapGeojson(geojson || null);
    }
  }, [geojson, zone]);

  return mapGeojson;
};
